//This file holds the API calls that hit the /user route for DRY purposes
import { APIRequest } from '../../lib/apiRequest';

export const getUsers = async () =>
  APIRequest.request({
    method: 'GET',
    url: `/users`
  });

